import { Box } from "@mui/material";
import DriverIssuesPopup from "../../components/Recruiting/DriverIssues/DriverIssuesPopup";
import DriverIssuesTable from "../../components/Recruiting/DriverIssues/DriverIssuesTable";

const DriverIssuesPage = () => (
  <Box className="incidents-page">
    <DriverIssuesPopup />
    <DriverIssuesTable />
  </Box>
);

export default DriverIssuesPage;
